<template>
    <div class="automation-action-settings">
        <div class="field">
            <label v-bind:class="{ 'label-danger': !isValid() }"
                >{{ t('automations-form-actions-feedback_link-form_label') }}
                <small class="label-danger" v-if="!isValid()"
                    >{{ t('automations-form-actions-feedback_link-form_error') }}</small
                >
            </label>
            <small v-html="t('automations-form-actions-feedback_link-form_help')">
            </small>
            <select class="form-control" v-model="forms_id">
                <option
                    v-for="form in forms"
                    :key="form.id"
                    :value="form.id"
                    :selected="forms_id === form.id"
                >
                    {{ form.name }}
                </option>
            </select>
        </div>
    </div>
</template>
<script>
import keviApi from "./../../../keviApi";
export default {
    props: {
        value: {},
        properties: Object,
    },
    data: function () {
        return {
            title: this.t("automations-form-actions-feedback_link-title"),
            description: this.t("automations-form-actions-feedback_link-description"),
            forms: [],
            forms_id: this.properties.forms_id
                ? this.properties.forms_id
                : null,
        };
    },
    mounted() {
        this.getForms();
        this.$emit("mounted", this);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changed: function () {
            this.$emit("propertiesUpdated", { forms_id: this.forms_id });
        },
        isValid: function () {
            return !!this.forms_id;
        },
        getForms() {
            this.forms = [];
            var options = keviApi.getOptions("forms");
            this.$http(options).then((response) => {
                if (response.status === 200) {
                    this.forms = [
                        ...response.body.filter((f) => f.questions?.length > 0),
                    ];
                    if (this.forms.length > 1) {
                        this.forms.unshift({
                            name: this.t("automations-form-actions-feedback_link-select_form_placeholder"),
                            id: null,
                        });
                    }
                    if (this.forms.length == 1) {
                        this.forms_id = this.forms[0].id;
                    }
                }
            });
        },
    },
    watch: {
        forms_id() {
            this.changed();
        },
        properties() {
            if (this.properties.forms_id) {
                this.forms_id = this.properties.forms_id;
            }
        },
    },
};
</script>
